import { IGridItem } from "helpers/legacy-cart/line-items/items-conversion-helper";
import { IGridEntry } from "types/cart/shipment-review";
import type { IProductSize } from "types/product";

export enum ColumnsKinds {
    IMAGE_URL = "IMAGE_URL",
    PRODUCT_LINK = "PRODUCT_LINK",
    MENU = "MENU",
    PRICE_WITH_STRIKETHROUGH = "PRICE_WITH_STRIKETHROUGH",
    DATE = "DATE",
}

export enum SizingViewComponents {
    ProductNameRenderer = "SizeViewProductNameRenderer",
    ImageRenderer = "SizeViewImageRenderer",
    ProductMenu = "ProductMenuRenderer",
    LocationMenu = "LocationMenuRenderer",
    DateCellRenderer = "DateCellRenderer",
    SelectRenderer = "selectRenderer",
    MultiSelectEditor = "multiSelectEditor",
    SelectEditor = "selectEditor",
    DetailsMenuRenderer = "DetailsMenuRenderer",
    InputRenderer = "InputRenderer",
    DetailsGridTotalsRowRenderer = "detailsGridTotalsRowRenderer",
    PriceWithStrikethrough = "PriceWithStrikethrough",
    DbpDeliveryCellRenderer = "DbpDeliveryCellRenderer",
}
export enum OtherViewComponents {
    CustomizationsRenderer = "CustomizationsRenderer",
}

export enum BufferContext {
    Row = "Row",
    SizesRow = "SizesRow",
    Quantity = "Quantity",
    Sizes = "Sizes",
    Generic = "Generic",
}

export enum EntryBufferType {
    Entry = "Entry",
    Size = "Size",
    Warehouse = "Warehouse",
    Generic = "Generic",
}

export interface BufferEntry {
    type: EntryBufferType;
    key: any;
    value: any;
}

export interface SizeBufferEntry extends BufferEntry {
    type: EntryBufferType.Size;
    key: string;
    value: number;
}
export interface GenericBufferEntry extends BufferEntry {
    type: EntryBufferType.Generic;
    key: string;
}
// one entry for each master row in location group
export interface LocationRowBufferEntry extends BufferEntry {
    type: EntryBufferType.Entry;
    key: {
        attributes: IGridItem["attributes"];
        productId: string;
        prebook: boolean; // TODO: remove within NU-50181
        location: string;
    };
    value: Array<{
        size: string;
        quantity: number;
        location: string;
        shipStart: Date;
        shipEnd: Date;
    }>;
}

export type BufferEntriesType = SizeBufferEntry | GenericBufferEntry | LocationRowBufferEntry;

export type GridBuffer = {
    context: BufferContext;
    entries: BufferEntriesType[] | null;
};

export type PasteSizeData = {
    item: IGridEntry;
    size: IProductSize;
    quantity: number;
};

export const MORE_MENU_COL_WIDTH = 40;

export const COLUMN_FIELDS = {
    LOCATION: "_location",
    SHIPMENT: "shipment",
};
